import styled from 'styled-components'

const Description = styled.div<{readonly error?: boolean}>`
    color: ${props => props.error === true ? '#F56363' : '#9E9E9E'};
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    margin-top: 8px;

    @media (min-width: 480px) {
        margin-top: 16px;
    }

    @media (min-width: 640px) {
        font-size: 12px;
        line-height: 16px;
    }

    @media (min-width: 960px) {
        margin-top: 12px;
        line-height: 14px;
    }
`

export default Description